import { components, services } from '@/utils'

export default function(h) {
  return h(
    components.textarea,
    {
      props: {
        value: this.proxy,
        label: this.getTranslate(`${services.settingsUser}.labels.smpp.ipAddresses`),
        hint: this.getTranslate(`${services.settingsUser}.hints.smpp.ipAddresses`),
        clearable: this.clearable,
        required: this.required,
        details: this.details,
        rows: 4,
        grow: true,
        dense: true
      },
      on: {
        input: event => {
          this.proxy = event
        }
      }
    }
  )
}
